var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 115 150",
    xmlSpace: "preserve",
    fill: "#C4B28F",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 120,
    r: 25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 75,
    r: 25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSeparator);
export default __webpack_public_path__ + "static/media/next-separator.ce1815ad5fdbabe0bb9275e2974e2b95.svg";
export { ForwardRef as ReactComponent };